import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import CloudUpload from '@material-ui/icons/CloudUpload';
import {Button, showNotification, UPDATE } from 'react-admin';
import { push } from 'react-router-redux';
import jsonAWSProvider from '../cognito';
const dataProvider = jsonAWSProvider("MyAPIGatewayAPI");

class SubmitButton extends Component {
    handleClick = () => {
        const { push, record, showNotification } = this.props;
        console.log(record)
        const updatedRecord = { ...record, action: 'submit for test' };
        dataProvider(UPDATE, 'customertest', { id: record.id, data: updatedRecord })
            .then((e) => {
                console.log(e)
                showNotification('Test Started');
                push('/');
            })
            .catch((e) => {
                console.error(e);
                showNotification('Error: Test not started', 'warning')
            });
    };

    render() {
        return (
            <div>
                {this.props.record.DensityTestStatus === 'Wait for Submit' ?
                    <Button
                        label="Submit for test"
                        onClick={this.handleClick}>
                        <CloudUpload />
                    </Button> :
                    <span></span>}
            </div>
        );
    }
}

SubmitButton.propTypes = {
    push: PropTypes.func,
    record: PropTypes.object,
    showNotification: PropTypes.func,
};

export default connect(null, {
    showNotification,
    push,
})(SubmitButton);